(function () {
  const root = document.documentElement;
  const validExperiences = ['alpine', 'rebuy'];

  function getCartExperience() {
    const experience = root.dataset.cartExperience;
    return validExperiences.includes(experience) ? experience : 'alpine';
  }

  function closeAlpineCart() {
    const store = window.Alpine?.store?.('cart');
    if (store?.isCartOpen) store.toggleCart(false);
  }

  function closeRebuyCart() {
    if (typeof window.Rebuy?.SmartCart?.hide === 'function') {
      window.Rebuy.SmartCart.hide();
    }
  }

  function openRebuyCart(button, attemptsLeft = 20) {
    if (typeof window.Rebuy?.SmartCart?.show === 'function') {
      window.Rebuy.SmartCart.show();
      return;
    }

    if (attemptsLeft > 0) {
      window.setTimeout(() => openRebuyCart(button, attemptsLeft - 1), 100);
      return;
    }

    window.location.assign(button.href);
  }

  function setCartExperience(experience) {
    if (!validExperiences.includes(experience)) return false;

    root.dataset.cartExperience = experience;
    if (experience === 'alpine') closeRebuyCart();
    // Temporarily disabled: switching to the 'rebuy' experience was force-closing
    // an already-open Alpine cart drawer (e.g. right after removing a line item),
    // most likely because Rebuy's own script calls setCartExperience('rebuy')
    // whenever it observes a /cart/*.js request, regardless of which UI made it.
    // Re-enable once that trigger is scoped to an explicit user action instead.
    // if (experience === 'rebuy') closeAlpineCart();

    document.dispatchEvent(new CustomEvent('cart:experience:changed', {
      detail: { experience }
    }));
    return true;
  }

  window.getCartExperience = getCartExperience;
  window.setCartExperience = setCartExperience;
  window.isAlpineCartExperience = () => getCartExperience() === 'alpine';

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-rebuy-cart-toggle]');
    if (!button || getCartExperience() !== 'rebuy') return;

    event.preventDefault();
    openRebuyCart(button);
  });

  document.addEventListener('rebuy:smartcart.show', () => {
    if (getCartExperience() === 'alpine') closeRebuyCart();
  });

  document.addEventListener('cart:experience:changed', (event) => {
    document.querySelectorAll('[data-cart-experience-button]').forEach((button) => {
      const isActive = button.dataset.cartExperienceButton === event.detail.experience;
      button.setAttribute('aria-hidden', String(!isActive));
      button.tabIndex = isActive ? 0 : -1;
    });
  });

  setCartExperience(getCartExperience());
})();
